import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LaboratoryTubesFilterComponent } from "./laboratory-tubes-filter/laboratory-tubes-filter.component";
import { LaboratoryTubesSearchComponent } from "./laboratory-tubes-search/laboratory-tubes-search.component";
import { LaboratoryTubesWizardComponent } from "./laboratory-tubes-wizard/laboratory-tubes-wizard.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AppMaterialModule } from "src/app/app.material.module";
import { PipesModule } from "src/app/pipes/pipes.module";
import { PatientAutocompleteModule } from "../autocomplete/patient/patient-autocomplete.module";
import { ControlsModule } from "../controls/controls.module";
import { SharedModule } from "../shared.module";
import { LaboratoryTubesControlsDialogComponent } from "./laboratory-tubes-controls-dialog/laboratory-tubes-controls-dialog.component";

@NgModule({
  declarations: [
    LaboratoryTubesFilterComponent,
    LaboratoryTubesSearchComponent,
    LaboratoryTubesWizardComponent,
    LaboratoryTubesControlsDialogComponent
  ],
  imports: [
    CommonModule,
    AppMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    PatientAutocompleteModule,
    PipesModule,
    ControlsModule
  ], entryComponents: [
     LaboratoryTubesControlsDialogComponent
  ]
})
export class LaboratoryTubesModule {}
